import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Col, Row } from '@microfrontends/react-components'

import { ICareerPathByIndustry } from './types'
import {
	IndustryCareerPathContainer,
	Title,
	Separate,
  ShowMoreBtn
} from './IndustryCareerPath.css'
import CareerPathByIndustry from './components/CareerPathByIndustry'
import AppContext from '../../../context/AppContext'

interface IProps {
	careerPathByIndustryData?: ICareerPathByIndustry[]
}

const INDUSTRIES_THRESHOLD = 2
export default function IndustryCareerPath({
	careerPathByIndustryData
}: IProps) {
	const { breakpoint } = useContext(AppContext)
	const [careerPathByIndustry, setCareerPathByIndustry] = useState<
		[ICareerPathByIndustry[]]
	>([[]])
	const [showAllIndustries, setShowAllIndustries] = useState(false)

	const slicedIndustries = useMemo(
		() =>
			careerPathByIndustry.slice(
				0,
				showAllIndustries
					? careerPathByIndustry.length
					: INDUSTRIES_THRESHOLD
			),
		[careerPathByIndustry, showAllIndustries]
	)

	useEffect(() => {
		if (careerPathByIndustryData && careerPathByIndustryData.length > 0) {
			const THRESHOLD = breakpoint === 'mobile' ? 2 : 4
			const convertedCareerPathByIndustry: [ICareerPathByIndustry[]] = [
				[]
			]
			let index = 0
			for (let i = 0; i < careerPathByIndustryData.length; ++i) {
				if (convertedCareerPathByIndustry[index].length < THRESHOLD) {
					convertedCareerPathByIndustry[index].push(
						careerPathByIndustryData[i]
					)
					continue
				}
				index++
				convertedCareerPathByIndustry[index] = [
					careerPathByIndustryData[i]
				]
			}
			setCareerPathByIndustry(convertedCareerPathByIndustry)
		}
	}, [careerPathByIndustryData, breakpoint])

	return careerPathByIndustry && careerPathByIndustry.length > 0 ? (
		<IndustryCareerPathContainer container={{ md: 12 }} gutter={[24, 0]}>
			<Col>
				<Title>
					BẠN MUỐN XEM LỘ TRÌNH SỰ NGHIỆP CỦA NGÀNH NGHỀ NÀO
				</Title>
			</Col>
			<Col>
				<Row gutter={{ xs: 16, sm: [32, 16] }} justify='center'>
					{slicedIndustries.map((industries, index) => {
						return (
							<React.Fragment key={index}>
								{index !== 0 ? (
									<Col>
										<Separate />
									</Col>
								) : null}
								<Col key={index}>
									<CareerPathByIndustry
										industries={industries}
									/>
								</Col>
							</React.Fragment>
						)
					})}
					{!showAllIndustries ? (
						<>
							<Col>
								<Separate />
							</Col>
							<Col>
								<ShowMoreBtn onClick={() => setShowAllIndustries(true)}>
									Xem thêm
								</ShowMoreBtn>
							</Col>
						</>
					) : null}
				</Row>
			</Col>
		</IndustryCareerPathContainer>
	) : null
}
